module.exports = "/assets/data/6af5720a2f78e8dc0bdf13a7db8651af-M4.data.json";